var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.timerOutput === null)?_c('span',{staticClass:"blackText"},[_vm._v("-")]):_c('span',{class:_vm.countDownClass},[_vm._v(_vm._s(_vm.timerOutput))])])
}
var staticRenderFns = []

export { render, staticRenderFns }